// Where the channel picker's list stands: being checked against Slack, checked, or why not.
import type { UseMutationResult } from "react-query";

import type { SlackChannelListResponse } from "../api/hooks/useSlack";
import styles from "./Slack.module.css";

export const SlackPickerStatus = ({
  refresh,
  botMention,
  available,
}: {
  refresh: UseMutationResult<SlackChannelListResponse, Error, void>;
  botMention: string;
  available: number;
}) => {
  const failure = refresh.error?.message ?? refresh.data?.refresh_error ?? null;
  const invite = `To add another, run /invite ${botMention} in that channel in Slack; this list updates when you come back to this tab.`;
  if (refresh.isLoading) {
    return (
      <p className={`${styles.hint} ${styles.checking}`} role="status">
        <span className={styles.spinner} aria-hidden />
        Checking Slack for the channels {botMention} has been invited to...
      </p>
    );
  }
  if (failure) {
    return <p className={styles.error}>Could not check Slack: {failure}</p>;
  }
  if (!refresh.data) return null;
  return (
    <p className={styles.hint} role="status">
      {available === 0
        ? `${botMention} is in no channel that can be added here. `
        : `Up to date with Slack: ${available} channel${available === 1 ? "" : "s"} can be added. `}
      {invite}
    </p>
  );
};
